<div>
  <div class="icon">
    <i class="fa-fw"
      [ngClass]="icon"
      aria-hidden="true">
    </i>
  </div>
  @if (keyTrad) {
    <div class="label"
      [innerHtml]="keyTrad | translate | tonbsp:true">
    </div>
  }
  <div class="value-container">
    @if (!value) {
      <div class="value"
        >
        <ng-content></ng-content>
      </div>
    }
    @if (value) {
      <div class="value"
        >
        {{value}}
      </div>
    }
  </div>
</div>
